import { SEO } from "gatsby-theme-catalyst-core";
import * as React from 'react';
export default {
  SEO,
  React
};